import create from 'zustand'
import shallow from 'zustand/shallow'
import {
  createApp,
  updateApp,
  destroyApp,
  recoveryApp,
  setStar,
  fetchAllApps,
} from '@vt/apis/lib-ex/v2/app'
import { Toast } from '@ow/comps'

const useStore = create((set, get) => ({
  contentEditOpened: false,
  appId: null,
  content: '',
  loading: false,
  filter: undefined,
  sections: {
    deleted: [],
    star: [],
    created: [],
    joined: [],
  },
  getList: async () => {
    const { filter } = get()
    const res = await fetchAllApps(filter)
    set({ sections: res })
  },
  setState: (state) => set(() => state),
  createApp: async (params) => {
    const { getList } = get()
    const res = await createApp(params)
    if (res.status === 0) {
      Toast.success({ title: '新建成功' })
      getList()
      return true
    }

    Toast.error({ title: '创建失败' })
    console.log(res)
    return false
  },
  updateApp: async (params) => {
    const { appId, getList } = get()
    set({ loading: true })
    try {
      const res = await updateApp(appId, params)
      set({ loading: false })
      if (res.status === 200) {
        Toast.success({ title: '保存成功' })
        getList()
        return true
      }
      Toast.error({ title: res.msg })
    } catch (err) {
      console.log(err)
      Toast.error({ title: '修改失败' })
      set({ loading: false })
    }

    return false
  },
  changeStatus: async (isDeleted) => {
    const { appId, getList } = get()
    let res
    try {
      if (isDeleted) {
        res = await recoveryApp(appId)
      } else {
        res = await destroyApp(appId)
      }

      if (res.status === 200) {
        Toast.success({ title: '修改成功' })
        getList()
        return true
      }
      Toast.error({ title: res.msg })
    } catch (err) {
      console.log(err)
      Toast.error({ title: '修改失败' })
    }

    return false
  },
  setAppStar: async (appId, star) => {
    const { getList } = get()
    const res = await setStar(appId, star)
    if (res.status === 200) {
      Toast.success({ title: '设置成功' })
      getList()
      return true
    }
    Toast.error({ title: res.msg })

    return false
  },
}))

const useAppListStore = (selector, equalityFn = shallow) =>
  useStore(selector, equalityFn)

export default useAppListStore
